// fp-ts fromEntries requires the arrays to have two members, but they also need to be typed as such
// ['key', value] is inferred as string[], and is rejected unless asserted as [string, string]
// makeEntry removes necessity of using as
export const makeEntry = <K extends string | number | symbol, T>(key: K, value: T): [K, T] => [key, value];
